export default __webpack_public_path__ + "static/media/yellow_bg.13f10df8.png";